const API_URL = "/api/contact";

const parseJson = async (response) => {
  try {
    return await response.json();
  } catch {
    return {};
  }
};

export const sendContactMessage = async (payload) => {
  const response = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data.message || "خطا در ارسال پیام");
  }

  return data;
};

export const getMessages = async (token) => {
  const response = await fetch(`${API_URL}/admin`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data.message || "خطا در دریافت پیام‌ها");
  }

  return data;
};

export const deleteMessage = async (id, token) => {
  const response = await fetch(`${API_URL}/admin/${id}`, {
    method: "DELETE",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data.message || "خطا در حذف پیام");
  }

  return data;
};

export const markAsRead = async (id, token) => {
  const response = await fetch(`${API_URL}/admin/${id}/read`, {
    method: "PATCH",
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const data = await parseJson(response);

  if (!response.ok) {
    throw new Error(data.message || "خطا در بروزرسانی پیام");
  }

  return data;
};
